import { render, staticRenderFns } from "./AddStudents.vue?vue&type=template&id=3f45bb49&"
import script from "./AddStudents.vue?vue&type=script&lang=js&"
export * from "./AddStudents.vue?vue&type=script&lang=js&"
import style0 from "./AddStudents.vue?vue&type=style&index=0&scope=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports